import { render, staticRenderFns } from "./overview-cell-download.vue?vue&type=template&id=594ec60e&scoped=true"
import script from "./overview-cell-download.vue?vue&type=script&lang=ts"
export * from "./overview-cell-download.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594ec60e",
  null
  
)

export default component.exports